import React from 'react';
import { Box, Button, SxStyleProp, Text } from '@tishman/components';
import { navigate } from 'gatsby';

import { getPrivateEventsPageNameForHeroCta } from '../../../utils/privateEventsPageName';

type TPrivateEventsHeroTextSection = {
  caption?: string;
  containerSx?: SxStyleProp;
  link?: string;
  showMobileCta: boolean;
  showTabletCta?: boolean;
  pageName: string;
};

export const PrivateEventsHeroCta = ({
  caption,
  containerSx = {},
  link,
  showMobileCta,
  showTabletCta = true,
  pageName,
}: TPrivateEventsHeroTextSection) => {
  return (
    <Box
      sx={{
        marginTop: ['48px', '32px'],
        display: [
          showMobileCta ? 'block' : 'none',
          showTabletCta ? 'block' : 'none',
          'block',
        ],
        ...containerSx,
      }}
    >
      {link && (
        <Button
          data-gtm-id={getPrivateEventsPageNameForHeroCta(pageName)}
          key={caption}
          onClick={() => navigate(link.includes('@') ? `mailto:${link}` : link)}
          sx={{
            mb: [2, 0],
            letterSpacing: 5,
            paddingTop: '20px',
            paddingBottom: '20px',
            display: ['inline-block', 'auto'],
            width: ['100%', 'auto'],
          }}
          variant="inverted"
        >
          {caption}
        </Button>
      )}
    </Box>
  );
};
